/* eslint-disable no-param-reassign */
import { http } from '../index';

export const getCountries = () => {
  return http
    .get(`/countires`)
    .then(res => res.data)
    .catch(error => error.response.data);
};
